(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ombrail-home-engine"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.OmbrailHome) return;
  const copyNode = document.querySelector('[data-oh-copy]');
  if (!copyNode) return;
  let copy;
  try { copy = JSON.parse(copyNode.textContent); } catch { return; }
  const KEY = 'ombrail.project.v1';
  const pieces = new Map();
  const media = window.matchMedia('(prefers-reduced-motion: reduce)');
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  const clean = (v, limit = 1600) => typeof v === 'string' ? v.replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f]/g, '').trim().slice(0, limit) : '';
  let draft = { brief: '', ambience: '', stone: '', scene: '', room: 'living', saved: false, hasPhoto: false };
  try {
    const raw = localStorage.getItem(KEY);
    const saved = raw && raw.length < 16000 ? JSON.parse(raw) : null;
    if (saved && saved.version === 1) draft = { brief: clean(saved.brief), ambience: clean(saved.ambience, 70), stone: clean(saved.stone, 80), scene: clean(saved.scene, 80), room: ['living', 'dining', 'bedroom', 'whole_home'].includes(saved.room) ? saved.room : 'living', saved: saved.saved === true, hasPhoto: saved.hasPhoto === true };
  } catch {}
  let photo = null;
  let photoSeq = 0;
  let toastTimer;
  let activePiece;
  let previousOverflow = '';
  let previewStone = '';
  let dbPromise;
  let homeReady = false;
  const selected = () => window.OmbrailSelection?.getItems() || [];
  const imageUrl = value => {
    try {
      const u = new URL(value, location.origin);
      return u.protocol === 'https:' && (u.hostname === 'cdn.shopify.com' || u.origin === location.origin && u.pathname.startsWith('/cdn/shop/')) ? u.href : '';
    } catch { return ''; }
  };
  function el(tag, text, className) {
    const n = document.createElement(tag);
    if (text !== undefined) n.textContent = text;
    if (className) n.className = className;
    return n;
  }
  function tell(message, error = false) {
    const n = document.querySelector('[data-oh-toast]');
    if (!n) return;
    clearTimeout(toastTimer);
    n.textContent = message;
    n.hidden = false;
    n.setAttribute('role', error ? 'alert' : 'status');
    toastTimer = setTimeout(() => { n.hidden = true; }, 4500);
  }
  function status(message, error = false) {
    document.querySelectorAll('[data-oh-project-status]').forEach(n => {
      n.textContent = message;
      n.classList.toggle('oh-error-text', error);
    });
  }
  function persist() {
    try {
      localStorage.setItem(KEY, JSON.stringify({ ...draft, version: 1, updatedAt: new Date().toISOString() }));
      return true;
    } catch { status(copy.storage_error, true); return false; }
  }
  function photoDb() {
    if (!dbPromise) dbPromise = new Promise((resolve, reject) => {
      const r = indexedDB.open('ombrail-project', 1);
      r.onupgradeneeded = () => { if (!r.result.objectStoreNames.contains('photos')) r.result.createObjectStore('photos'); };
      r.onsuccess = () => resolve(r.result);
      r.onerror = () => reject(r.error);
      r.onblocked = () => reject(new Error('storage-blocked'));
    });
    return dbPromise;
  }
  async function photoStore(action, value) {
    const db = await photoDb();
    return new Promise((resolve, reject) => {
      const tx = db.transaction('photos', action === 'get' ? 'readonly' : 'readwrite');
      const store = tx.objectStore('photos');
      const request = action === 'put' ? store.put(value, 'current') : action === 'delete' ? store.delete('current') : store.get('current');
      let result;
      request.onsuccess = () => { result = request.result; };
      tx.oncomplete = () => resolve(result);
      tx.onerror = () => reject(tx.error);
      tx.onabort = () => reject(tx.error);
    });
  }
  function register() {
    document.querySelectorAll('[data-oh-product]').forEach(n => {
      try {
        const p = JSON.parse(n.textContent);
        if (!p.key || !/^[a-z0-9-]+$/.test(p.key) || !imageUrl(p.image)) return;
        if (!pieces.has(p.key) || n.hasAttribute('data-oh-editorial')) pieces.set(p.key, p);
      } catch {}
    });
  }
  function updatePhoto() {
    document.querySelectorAll('[data-oh-room-photo]').forEach(n => {
      n.src = photo?.data || n.dataset.default;
      n.alt = photo ? copy.your_photo : n.dataset.defaultAlt;
    });
    document.querySelectorAll('[data-oh-photo-remove]').forEach(n => { n.hidden = !photo; });
    document.querySelectorAll('[data-oh-photo-caption]').forEach(n => { n.textContent = photo ? copy.your_space : copy.starting_point; });
    document.querySelectorAll('[data-oh-photo-note]').forEach(n => { n.hidden = !photo; });
  }
  function notes() {
    document.querySelectorAll('[data-oh-board-notes]').forEach(n => { n.hidden = !draft.brief; });
    document.querySelectorAll('[data-oh-board-brief]').forEach(n => { n.textContent = draft.brief; });
  }
  function board() {
    const items = selected();
    notes();
    document.querySelectorAll('[data-oh-room-type]').forEach(n => { n.value = draft.room; });
    document.querySelectorAll('[data-oh-board-swatch]').forEach(n => { n.classList.toggle('is-picked', n.dataset.ohBoardSwatch === draft.stone); });
    document.querySelectorAll('[data-oh-project-saved]').forEach(n => { n.hidden = items.length === 0; });
    document.querySelectorAll('[data-oh-saved-count]').forEach(n => { n.textContent = String(items.length); });
    document.querySelectorAll('[data-oh-board-material]').forEach(n => { n.textContent = draft.stone || copy.board_material; });
    document.querySelectorAll('[data-oh-board-ambience]').forEach(n => { n.textContent = draft.ambience || copy.board_ambience; });
    document.querySelectorAll('[data-oh-mood]').forEach(n => { n.setAttribute('aria-pressed', String(n.dataset.ohMood === draft.ambience)); });
    document.querySelectorAll('[data-oh-save],[data-oh-room-add]').forEach(n => {
      const key = n.dataset.ohSave || n.dataset.ohRoomAdd;
      const p = pieces.get(key);
      const exists = p && items.some(i => i.reference === p.reference);
      n.setAttribute('aria-pressed', String(!!exists));
      n.setAttribute('aria-label', `${exists ? copy.remove : copy.save_piece}: ${p?.title || ''}`);
      const label = n.querySelector('[data-oh-save-label]');
      if (label) label.textContent = exists ? copy.saved : copy.save_piece;
    });
    document.querySelectorAll('[data-oh-saved-items]').forEach(n => {
      n.replaceChildren(...items.map(item => {
        const card = el('article', undefined, 'oh-project-item');
        const img = el('img'); img.src = item.image; img.alt = item.title; img.width = 150; img.height = 150; img.loading = 'lazy';
        const b = el('button', '×'); b.type = 'button'; b.dataset.ohRemove = item.reference; b.setAttribute('aria-label', `${copy.remove}: ${item.title}`);
        card.append(img, el('p', item.title), b);
        return card;
      }));
    });
    if (activePiece) {
      const save = document.querySelector('[data-oh-dialog-save]');
      if (save) {
        const exists = items.some(i => i.reference === activePiece.reference);
        save.setAttribute('aria-pressed', String(exists));
        save.querySelector('span').textContent = exists ? copy.saved : copy.save_piece;
      }
    }
  }
  function togglePiece(key, forceAdd = false) {
    const p = pieces.get(key);
    if (!p || !window.OmbrailSelection) return false;
    const exists = selected().some(i => i.reference === p.reference);
    if (exists && !forceAdd) {
      window.OmbrailSelection.remove(p.reference);
      tell(copy.removed);
      return true;
    }
    if (exists) return true;
    document.dispatchEvent(new CustomEvent('ombrail:add-selection', { detail: { ...p, stay: true, guidePrice: p.guidePrice || null, guideCurrency: p.guideCurrency || null, purchaseMode: p.purchaseMode || 'quote', quantity: 1, moq: 1, unit: 'piece' } }));
    const added = selected().some(i => i.reference === p.reference);
    if (added && !forceAdd && window.OmbrailSelection.isPersisted?.() !== false) tell(copy.piece_saved);
    return added;
  }
  function openPiece(key) {
    const p = pieces.get(key);
    const dialog = document.querySelector('[data-oh-dialog]');
    if (!p || !dialog) return;
    activePiece = p;
    const img = dialog.querySelector('[data-oh-dialog-image]'); img.loading = 'eager'; img.src = p.image; img.alt = p.title;
    ['title', 'description', 'material', 'dimensions', 'reference', 'price'].forEach(k => {
      const n = dialog.querySelector(`[data-oh-dialog-${k}]`);
      if (n) n.textContent = p[k] || copy.on_request;
    });
    const link = dialog.querySelector('[data-oh-dialog-link]');
    const target = new URL(p.url,location.origin);if(!p.live){target.searchParams.set('reference',p.reference);target.searchParams.set('title',p.title);}link.href = target.href; link.querySelector('span').textContent = p.live ? copy.view_piece : copy.discuss_piece;
    board();
    if (!dialog.open) { previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; dialog.showModal(); }
  }
  function setRoom(key, scroll = false) {
    const root = document.querySelector('[data-oh-room]');
    if (!root) return;
    root.querySelectorAll('[data-oh-hotspot]').forEach(n => { n.setAttribute('aria-pressed', String(n.dataset.ohHotspot === key)); });
    root.querySelectorAll('[data-oh-room-panel]').forEach(n => { n.hidden = n.dataset.ohRoomPanel !== key; });
    root.querySelectorAll('[data-oh-room-select]').forEach(n => { n.setAttribute('aria-pressed', String(n.dataset.ohRoomSelect === key)); });
    root.querySelectorAll('[data-oh-room-card]').forEach(n => {
      const active = n.dataset.ohRoomCard === key;
      n.classList.toggle('is-active', active);
      if (active && scroll && !root.classList.contains('oh-room--interactive') && matchMedia('(max-width:760px)').matches) {
        const rail = n.parentElement;
        rail.scrollTo({ left: n.offsetLeft - rail.offsetLeft, behavior: media.matches ? 'auto' : 'smooth' });
      }
    });
    const p = pieces.get(key);
    const statusNode = root.querySelector('[data-oh-room-status]');
    if (p && statusNode) statusNode.textContent = p.title;
  }
  function selectStone(button) {
    const root = button.closest('[data-oh-stones]');
    if (!root) return;
    previewStone = button.dataset.ohStone;
    root.querySelectorAll('[data-oh-stone]').forEach(n => {
      const active = n === button;
      n.setAttribute('aria-selected', String(active)); n.tabIndex = active ? 0 : -1;
    });
    root.querySelectorAll('[data-oh-slab]').forEach(n => { n.classList.toggle('is-active', n.dataset.ohSlab === previewStone); });
    root.querySelectorAll('[data-oh-stone-panel]').forEach(n => {
      const active = n.dataset.ohStonePanel === previewStone;
      n.hidden = !active;
    });
    root.querySelector('[data-oh-stone-index]').textContent = button.dataset.number;
    const browse=root.querySelector('[data-oh-stone-browse]');if(browse){browse.href=button.dataset.collection;}
  }
  function briefText() {
    const lines = [copy.brief_title, ''];
    if (draft.brief) lines.push(draft.brief, '');
    const roomChoice = document.querySelector('[data-oh-room-type] option:checked');
    if (roomChoice) lines.push(roomChoice.textContent);
    if (draft.ambience) lines.push(`${copy.ambience}: ${draft.ambience}`);
    if (draft.stone) lines.push(`${copy.material}: ${draft.stone}`);
    if (draft.scene) lines.push(`${copy.inspiration}: ${draft.scene}`);
    selected().forEach((p, i) => lines.push('', `${i + 1}. ${p.title}`, `${copy.reference}: ${p.reference}`, `${copy.material}: ${p.material}`, new URL(p.url, location.origin).href));
    return lines.join('\n').slice(0,3900);
  }
  function saveDraft(showNotice = true) {
    const input = document.querySelector('[data-oh-brief]');
    if (input) draft.brief = clean(input.value);
    if (!draft.brief && !draft.ambience && !draft.stone && !selected().length && !photo) {
      status(copy.empty_project, true); input?.focus(); return false;
    }
    draft.saved = true;
    const ok = persist();
    board();
    if (ok && showNotice) status(copy.project_saved);
    return ok;
  }
  async function selectPhoto(file, input) {
    if (!file) return;
    const seq = ++photoSeq;
    if (!['image/jpeg','image/png','image/webp'].includes(file.type)) { status(copy.photo_type_error, true); input.value = ''; return; }
    if (file.size > 12 * 1024 * 1024) { status(copy.photo_size_error, true); input.value = ''; return; }
    status(copy.photo_loading);
    try {
      const temp = URL.createObjectURL(file);
      let img;
      try {
        img = new Image(); img.src = temp; await img.decode();
        if (!img.naturalWidth || !img.naturalHeight || img.naturalWidth * img.naturalHeight > 80000000) throw new Error('image-size');
        const factor = Math.min(1, 1600 / Math.max(img.naturalWidth,img.naturalHeight));
        const canvas = document.createElement('canvas'); canvas.width = Math.round(img.naturalWidth * factor); canvas.height = Math.round(img.naturalHeight * factor);
        const ctx = canvas.getContext('2d'); ctx.fillStyle = '#f3f0e9'; ctx.fillRect(0,0,canvas.width,canvas.height); ctx.drawImage(img,0,0,canvas.width,canvas.height);
        const next = { data: canvas.toDataURL('image/jpeg', .82), name: 'Ombrail-my-room.jpg' };
        if (seq !== photoSeq) return;
        await photoStore('put', next);
        if (seq !== photoSeq) return;
        photo = next; draft.hasPhoto = true; draft.saved = true;
        const saved = persist(); updatePhoto(); board();
        if (saved) status(copy.photo_saved);
      } finally { URL.revokeObjectURL(temp); }
    } catch { status(copy.photo_error, true); }
    input.value = '';
  }
  async function shareProject() {
    if (!saveDraft(false)) return;
    const text = briefText();
    try {
      let files;
      if (photo) {
        const bytes = Uint8Array.from(atob(photo.data.split(',')[1]), c => c.charCodeAt(0));
        files = [new File([bytes], 'Ombrail-my-room.jpg', { type: 'image/jpeg' })];
      }
      const payload = { title: copy.brief_title, text, ...(files ? { files } : {}) };
      if (navigator.share && (!files || navigator.canShare?.({files}))) {
        await navigator.share(payload); return;
      }
      const esc = s => String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
      const cards = selected().map(p => `<article><img src="${esc(imageUrl(p.image))}" alt="${esc(p.title)}"><p>${esc(p.title)}<br><small>${esc(p.reference)} · ${esc(p.material)}</small></p></article>`).join('');
      const html = `<!doctype html><html lang="en"><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>${esc(copy.brief_title)}</title><style>body{margin:0;background:#f3f0e9;color:#343c30;font:15px/1.7 Arial,sans-serif;padding:5vw}main{max-width:900px;margin:auto}h1{font:70px Georgia,serif;letter-spacing:-4px}pre{font:inherit;white-space:pre-wrap}img{max-width:100%}.photo{width:100%;max-height:550px;object-fit:contain}.cards{display:grid;grid-template-columns:repeat(3,1fr);gap:20px}article img{width:100%;aspect-ratio:1;object-fit:cover}small{color:#626557}@media(max-width:500px){.cards{grid-template-columns:1fr 1fr}}@media print{body{padding:0}.photo{max-height:400px}}</style><main><h1>ombrail</h1><h2>${esc(copy.brief_title)}</h2>${photo?`<img class="photo" src="${photo.data}" alt="${esc(copy.your_photo)}">`:''}<pre>${esc(text)}</pre><div class="cards">${cards}</div></main></html>`;
      const url = URL.createObjectURL(new Blob([html], {type:'text/html;charset=utf-8'}));
      const a = el('a'); a.href = url; a.download = 'Ombrail-my-project.html'; document.body.append(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000); status(copy.project_downloaded);
    } catch (e) { if (e.name !== 'AbortError') status(copy.share_error, true); }
  }
  function bridge(refresh = false) {
    if (!homeReady || !window.OmbrailSelection) return;
    const root = document.querySelector('[data-o-projects]');
    const form = root?.querySelector('.o-projects-form');
    if (!form || form.dataset.ohBridge && !refresh) return;
    root.querySelector('.oh-bridge')?.remove();
    form.dataset.ohBridge = 'true';
    const queryPiece = new URLSearchParams(location.search).get('piece');
    if (queryPiece) {
      register();
      const found = [...pieces.values()].find(p => p.handle === queryPiece);
      if (found) togglePiece(found.key, true);
    }
    if (!draft.saved && !selected().length) return;
    const n = el('div', undefined, 'oh-bridge');
    n.append(el('p', copy.brief_resumed));
    if (draft.ambience || draft.stone) n.append(el('p', [draft.ambience,draft.stone].filter(Boolean).join(' · ')));
    const a = el('a', copy.edit_project, 'oh-line'); a.href = `${copy.home_url}pages/projects#ombrail-project`; n.append(a);
    if (photo) {
      const img = el('img',undefined,'oh-bridge__photo'); img.src = photo.data; img.alt = copy.your_photo; n.append(img,el('p',copy.photo_send_note));
    }
    const target = root.querySelector('.o-projects-brief>div'); (target || form).append(n);
    const body = form.querySelector('textarea[name="contact[body]"]');
    if (body && (!body.value || body.value === body.dataset.ohAutoBrief)) { body.value = briefText(); body.dataset.ohAutoBrief = body.value; }
    const style = form.querySelector('input[name="contact[Style and materials]"]');
    if (style && (!style.value || style.value === style.dataset.ohAutoStyle)) { style.value = [draft.ambience,draft.stone].filter(Boolean).join(' · '); style.dataset.ohAutoStyle = style.value; }
    const room = form.querySelector(`[data-o-room-value="${draft.room}"]`); if (room) room.checked = true;
  }
  function connect() {
    register();
    document.querySelectorAll('[data-oh-brief]').forEach(n => { if (!n.dataset.connected) { n.value = draft.brief; n.dataset.connected='true'; } });
    document.querySelectorAll('[data-oh-stones]').forEach(root => {
      if (root.dataset.connected) return;
      root.dataset.connected='true';
      const initial = [...root.querySelectorAll('[data-oh-stone]')].find(n => n.dataset.ohStone === draft.stone) || root.querySelector('[data-oh-stone]');
      if (initial) selectStone(initial);
      root.querySelectorAll('[data-oh-stone]').forEach(n => {
        let timer;
        n.addEventListener('pointerenter', () => { if (fine.matches) timer = setTimeout(() => selectStone(n), 120); });
        n.addEventListener('pointerleave', () => clearTimeout(timer));
        n.addEventListener('keydown', event => {
          const tabs = [...root.querySelectorAll('[data-oh-stone]')];
          let index = tabs.indexOf(n);
          if (['ArrowDown','ArrowRight'].includes(event.key)) index = (index + 1) % tabs.length;
          else if (['ArrowUp','ArrowLeft'].includes(event.key)) index = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = tabs.length - 1;
          else return;
          event.preventDefault(); selectStone(tabs[index]); tabs[index].focus();
        });
      });
    });
    updatePhoto(); board();
  }
  document.addEventListener('click', event => {
    const quick = event.target.closest('[data-oh-quick]'); if (quick) { event.preventDefault(); openPiece(quick.dataset.ohQuick); return; }
    const save = event.target.closest('[data-oh-save],[data-oh-room-add]'); if (save) { event.preventDefault(); togglePiece(save.dataset.ohSave || save.dataset.ohRoomAdd); return; }
    const remove = event.target.closest('[data-oh-remove]'); if (remove) { window.OmbrailSelection?.remove(remove.dataset.ohRemove); return; }
    const roomChoice = event.target.closest('[data-oh-room-select]'); if (roomChoice) { setRoom(roomChoice.dataset.ohRoomSelect, false); return; }
    const dot = event.target.closest('[data-oh-hotspot]'); if (dot) { setRoom(dot.dataset.ohHotspot, true); return; }
    const focus = event.target.closest('[data-oh-room-focus]'); if (focus) { setRoom(focus.dataset.ohRoomFocus, false); openPiece(focus.dataset.ohRoomFocus); return; }
    const stone = event.target.closest('[data-oh-stone]'); if (stone) { selectStone(stone); return; }
    const materialSave = event.target.closest('[data-oh-save-stone]'); if (materialSave) { draft.stone = previewStone; draft.saved = true; if (persist()) tell(copy.stone_saved); board(); return; }
    const mood = event.target.closest('[data-oh-mood]'); if (mood) { draft.ambience = draft.ambience === mood.dataset.ohMood ? '' : mood.dataset.ohMood; persist(); board(); return; }
    if (event.target.closest('[data-oh-save-project]')) { saveDraft(); return; }
    if (event.target.closest('[data-oh-share-project]')) { shareProject(); return; }
    if (event.target.closest('[data-oh-continue-project]')) { if (draft.brief || draft.ambience || draft.stone || selected().length || photo) { if (!saveDraft(false)) { event.preventDefault(); return; } } if(document.querySelector('[data-o-projects]')) { event.preventDefault(); bridge(true); document.querySelector('#ombrail-project-brief')?.scrollIntoView({behavior:media.matches?'auto':'smooth',block:'start'}); } return; }
    if (event.target.closest('[data-oh-photo-remove]')) {
      ++photoSeq;
      photoStore('delete').then(() => { photo = null; draft.hasPhoto = false; persist(); updatePhoto(); board(); status(copy.photo_removed); }).catch(() => status(copy.storage_error,true)); return;
    }
    if (event.target.closest('[data-oh-dialog-close]')) { document.querySelector('[data-oh-dialog]')?.close(); return; }
    if (event.target.closest('[data-oh-dialog-save]')) { if (activePiece) togglePiece(activePiece.key); return; }
    const roomSave = event.target.closest('[data-oh-use-room]');
    if (roomSave) {
      event.preventDefault();
      document.querySelectorAll('[data-oh-room-card]').forEach(n => togglePiece(n.dataset.ohRoomCard, true));
      draft.ambience = copy.warm_minimal; draft.scene = copy.room_name; draft.saved = true;
      persist(); board(); tell(copy.room_saved);
      location.assign(`${copy.home_url}pages/projects#ombrail-project`); return;
    }
    const filter = event.target.closest('[data-oh-filter]');
    if (filter) {
      const root = filter.closest('[data-oh-edit]');
      const mode = filter.dataset.ohFilter;
      root.querySelectorAll('[data-oh-filter]').forEach(n => n.setAttribute('aria-pressed', String(n===filter)));
      root.querySelectorAll('[data-oh-edit-item]').forEach(n => { n.hidden = mode !== 'all' && n.dataset.family !== mode; });
    }
  });
  document.addEventListener('input', event => {
    if (event.target.matches('[data-oh-brief]')) { draft.brief = clean(event.target.value); persist(); notes(); status(''); }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-oh-room-type]')) { draft.room = event.target.value; draft.saved = true; persist(); board(); }
    if (event.target.matches('[data-oh-photo-input]')) selectPhoto(event.target.files?.[0], event.target);
  });
  document.addEventListener('pointerover', event => { const card = event.target.closest('[data-oh-room-card]'); if (card && fine.matches) setRoom(card.dataset.ohRoomCard, false); });
  document.addEventListener('focusin', event => { const card = event.target.closest('[data-oh-room-card]'); if (card) setRoom(card.dataset.ohRoomCard, false); });
  document.addEventListener('ombrail:selection-change', () => { board(); bridge(); });
  document.addEventListener('shopify:section:load', connect);
  const dialog = document.querySelector('[data-oh-dialog]');
  dialog?.addEventListener('close', () => { document.body.style.overflow = previousOverflow; });
  dialog?.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) dialog.close(); } });
  window.OmbrailHome = Object.freeze({ refresh: connect });
  async function start() {
    connect();
    if (draft.hasPhoto) { try { photo = await photoStore('get'); if (photo && !/^data:image\/jpeg;base64,/.test(photo.data || '')) photo=null; } catch { status(copy.storage_error,true); } }
    homeReady = true;
    updatePhoto(); board(); bridge();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ombrail-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__ombrailCardAdd) return;
  window.__ombrailCardAdd = true;
  function items() { return (window.OmbrailSelection && window.OmbrailSelection.getItems()) || []; }
  function sync() {
    var refs = items().map(function (i) { return i.reference; });
    document.querySelectorAll('[data-o-card-add]').forEach(function (b) {
      var on = refs.indexOf(b.dataset.reference) !== -1;
      b.setAttribute('aria-pressed', String(on));
      b.title = on ? 'In your selection. Click to remove.' : 'Save to your selection: one quote for several pieces';
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-o-card-add]');
    if (!b) return;
    e.preventDefault();
    if (b.getAttribute('aria-pressed') === 'true' && window.OmbrailSelection) { window.OmbrailSelection.remove(b.dataset.reference); return; }
    var data; try { data = JSON.parse(b.dataset.oCardAdd); } catch (err) { return; }
    document.dispatchEvent(new CustomEvent('ombrail:add-selection', { detail: Object.assign(data, { quantity: data.moq, configuration: 'standard', notes: '', stay: true }), bubbles: true }));
  });
  document.addEventListener('ombrail:selection-change', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ombrail-product-faq"] && !Shopify.designMode) return;
  try {
    (function () {
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-o-faq-suggest]');
    if (!chip) return;
    var form = chip.closest('.o-faq__ask') && chip.closest('.o-faq__ask').querySelector('[data-o-faq-form]');
    var input = form && form.querySelector('[data-o-faq-input]');
    if (!input) return;
    e.stopPropagation();
    input.value = chip.textContent;
    if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
  }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ombrail-product-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
  function bind(scope) {
    scope.querySelectorAll('[data-o-gallery]').forEach(function (root) {
      if (root.dataset.oGalleryBound) return;
      root.dataset.oGalleryBound = 'true';
      var rail = root.querySelector('[data-o-gallery-rail]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-o-gallery-slide]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-o-gallery-thumb]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('.o-gallery__dots span'));
      var lens = root.querySelector('[data-o-gallery-lens]');
      var viewer = root.querySelector('[data-o-viewer]');
      var frame = root.querySelector('[data-o-viewer-frame]');
      var big = root.querySelector('[data-o-viewer-image]');
      var count = root.querySelector('[data-o-viewer-count]');
      var hint = root.querySelector('[data-o-viewer-hint]');
      var drawingBox = root.querySelector('[data-o-viewer-drawing]');
      if (!rail || !slides.length) return;
      var active = 0, opener = null;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      function mark(index) {
        active = (index + slides.length) % slides.length;
        thumbs.forEach(function (t, i) { t.setAttribute('aria-current', String(i === active)); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
      }
      function go(index) {
        mark(index);
        rail.scrollTo({ left: slides[active].offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
      }
      var ticking = false;
      rail.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () { ticking = false; mark(Math.round(rail.scrollLeft / Math.max(1, rail.clientWidth))); });
      }, { passive: true });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      // Desktop: hovering a thumbnail shows that image right away (short delay so a quick pass across the column does not flicker).
      if (finePointer) {
        var hoverTimer;
        thumbs.forEach(function (t, i) {
          t.addEventListener('mouseenter', function () {
            clearTimeout(hoverTimer);
            hoverTimer = setTimeout(function () { if (i === active) return; mark(i); rail.scrollTo({ left: slides[active].offsetLeft, behavior: 'auto' }); }, 70);
          });
          t.addEventListener('mouseleave', function () { clearTimeout(hoverTimer); });
        });
      }
      root.querySelectorAll('[data-o-gallery-step]').forEach(function (b) { b.addEventListener('click', function () { go(active + Number(b.dataset.oGalleryStep)); }); });

      /* Hover magnifier: only for photographs large enough to stay sharp. */
      if (finePointer && lens) {
        slides.forEach(function (slide) {
          if (!slide.hasAttribute('data-zoomable')) return;
          slide.classList.add('is-zoomable');
          var loaded = false;
          slide.addEventListener('mouseenter', function () {
            if (!loaded) { lens.style.backgroundImage = 'url("' + slide.dataset.full + '")'; loaded = true; }
            else lens.style.backgroundImage = 'url("' + slide.dataset.full + '")';
            lens.classList.add('is-on');
          });
          slide.addEventListener('mousemove', function (e) {
            var r = slide.getBoundingClientRect();
            var x = Math.min(100, Math.max(0, (e.clientX - r.left) / r.width * 100));
            var y = Math.min(100, Math.max(0, (e.clientY - r.top) / r.height * 100));
            lens.style.backgroundPosition = x + '% ' + y + '%';
          });
          slide.addEventListener('mouseleave', function () { lens.classList.remove('is-on'); });
        });
      }

      /* Full-screen viewer */
      function show(index) {
        mark(index);
        var slide = slides[active];
        frame.classList.remove('is-zoomed');
        var canZoom = slide.hasAttribute('data-zoomable');
        frame.classList.toggle('can-zoom', canZoom);
        if (hint) hint.hidden = !canZoom;
        var isDrawing = slide.hasAttribute('data-o-drawing');
        frame.classList.toggle('is-drawing', isDrawing);
        if (drawingBox) {
          drawingBox.hidden = !isDrawing;
          drawingBox.innerHTML = isDrawing ? slide.querySelector('svg').outerHTML : '';
        }
        big.hidden = isDrawing;
        if (!isDrawing) { big.src = slide.dataset.full; big.alt = slide.dataset.alt || ''; }
        if (count) count.textContent = slides.length > 1 ? (active + 1) + ' / ' + slides.length : '';
      }
      function open(index, trigger) {
        if (!viewer || typeof viewer.showModal !== 'function') return;
        opener = trigger; show(index); viewer.showModal();
      }
      root.querySelectorAll('[data-o-gallery-open]').forEach(function (b) {
        b.addEventListener('click', function () { open(Number(b.dataset.oGalleryOpen), b); });
      });
      root.addEventListener('ombrail:show-drawing', function () {
        var index = slides.findIndex(function (s) { return s.hasAttribute('data-o-drawing'); });
        if (index > -1) go(index);
      });
      if (!viewer) return;
      viewer.querySelector('[data-o-viewer-close]').addEventListener('click', function () { viewer.close(); });
      viewer.querySelectorAll('[data-o-viewer-step]').forEach(function (b) { b.addEventListener('click', function () { show(active + Number(b.dataset.oViewerStep)); }); });
      viewer.addEventListener('close', function () { go(active); if (opener && opener.isConnected) opener.focus({ preventScroll: true }); });
      viewer.addEventListener('keydown', function (e) {
        if (slides.length > 1 && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) { e.preventDefault(); show(active + (e.key === 'ArrowRight' ? 1 : -1)); }
      });
      big.addEventListener('click', function (e) {
        if (!frame.classList.contains('can-zoom')) return;
        var zoomed = frame.classList.toggle('is-zoomed');
        if (zoomed) {
          var r = big.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
          requestAnimationFrame(function () {
            frame.scrollLeft = px * frame.scrollWidth - frame.clientWidth / 2;
            frame.scrollTop = py * frame.scrollHeight - frame.clientHeight / 2;
          });
        }
      });
      var sx = null, sy = null;
      frame.addEventListener('touchstart', function (e) { if (e.touches.length === 1) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; } else sx = null; }, { passive: true });
      frame.addEventListener('touchend', function (e) {
        if (sx === null || frame.classList.contains('is-zoomed') || slides.length < 2) return;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) show(active + (dx < 0 ? 1 : -1));
        sx = null;
      }, { passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(document); });
  else bind(document);
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ombrail-recently-viewed"] && !Shopify.designMode) return;
  try {
    (function () {
  var KEY = 'ombrail.recent.v1';
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text) n.textContent = text; return n; }
  function init() {
    document.querySelectorAll('[data-o-recent]').forEach(function (root) {
      if (root.dataset.bound) return; root.dataset.bound = 'true';
      var current; try { current = JSON.parse(root.querySelector('[data-o-recent-current]').textContent); } catch (e) { return; }
      var previous = read().filter(function (i) { return i && i.handle && i.handle !== current.handle; });
      write([current].concat(previous).slice(0, 12));
      var track = root.querySelector('[data-o-recent-track]');
      function render(list) {
        track.replaceChildren();
        if (list.length < 2) { root.hidden = true; return; }
        var saved = ((window.OmbrailSelection && window.OmbrailSelection.getItems()) || []).map(function (i) { return i.reference; });
        list.slice(0, 8).forEach(function (item) {
          var card = el('article', 'o-card o-recent__card');
          var media = el('div', 'o-card__image');
          if (item.image) { var img = el('img', 'o-card__img'); img.src = item.image; img.alt = item.title || ''; img.loading = 'lazy'; img.width = 600; img.height = 600; media.append(img); }
          card.append(media);
          if (item.save && item.save.reference) {
            var on = saved.indexOf(item.save.reference) !== -1;
            var b = el('button', 'o-card__add'); b.type = 'button';
            b.dataset.oCardAdd = JSON.stringify(item.save); b.dataset.reference = item.save.reference;
            b.setAttribute('aria-pressed', String(on)); b.setAttribute('aria-label', 'Save ' + item.title + ' to your selection');
            b.title = on ? 'In your selection. Click to remove.' : 'Save to your selection: one quote for several pieces';
            b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 4h10v16l-5-3.6L7 20z"/></svg><span class="o-card__add-off">Save</span><span class="o-card__add-on">Saved</span>';
            card.append(b);
          }
          var body = el('div', 'o-card__body');
          var h = el('h3'); var a = el('a', 'o-card__link', item.title); a.href = item.url; h.append(a); body.append(h);
          var meta = [item.material, item.sizes || item.dimensions].filter(Boolean).join(' · ');
          if (meta) body.append(el('p', 'o-card__dimensions', meta));
          if (item.price) body.append(el('p', 'o-recent__price', item.price));
          card.append(body); track.append(card);
        });
        root.hidden = false;
      }
      render(previous);
      root.querySelector('[data-o-recent-clear]').addEventListener('click', function () { write([current]); render([]); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ombrail-selection-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
  var pending = null;
  window.addEventListener('ombrail:add-selection', function (e) {
    pending = e.detail && e.detail.reference ? String(e.detail.reference) : '';
  }, true);
  function init() {
  var drawer = document.querySelector('[data-o-sel-drawer]');
  if (!drawer || drawer.dataset.bound) return;
  drawer.dataset.bound = 'true';
  var list = drawer.querySelector('[data-o-sel-list]');
  var countNode = drawer.querySelector('[data-o-sel-count]');
  var cta = drawer.querySelector('[data-o-sel-cta]');
  var status = drawer.querySelector('[data-o-sel-status]');
  var wa = drawer.querySelector('[data-o-sel-wa]');
  function items() { return (window.OmbrailSelection && window.OmbrailSelection.getItems()) || []; }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text !== undefined) n.textContent = text; return n; }
  function money(v) { try { return new Intl.NumberFormat('en-SG', { style: 'currency', currency: 'SGD', maximumFractionDigits: 0 }).format(v); } catch (e) { return 'S$' + v; } }
  function render(highlight) {
    var all = items();
    countNode.textContent = '(' + all.length + ')';
    cta.textContent = all.length > 1 ? 'Request one quote for ' + all.length + ' pieces' : 'Request a quote';
    list.replaceChildren();
    all.slice().reverse().forEach(function (item) {
      var li = el('li', 'o-sel-drawer__item' + (item.reference === highlight ? ' is-new' : ''));
      var media = el('a', 'o-sel-drawer__media'); media.href = item.url; media.tabIndex = -1;
      if (item.image) { var img = el('img'); img.src = item.image; img.alt = ''; img.loading = 'lazy'; media.append(img); }
      var body = el('div', 'o-sel-drawer__body');
      var title = el('a', 'o-sel-drawer__title', item.title); title.href = item.url;
      body.append(title);
      var meta = [item.dimensions, 'Ref. ' + item.reference].filter(Boolean).join(' · ');
      body.append(el('p', 'o-sel-drawer__meta', meta));
      body.append(el('p', 'o-sel-drawer__price', item.guidePrice ? money(item.guidePrice) + ' indicative' : 'Price on request'));
      var remove = el('button', 'o-sel-drawer__remove', 'Remove'); remove.type = 'button';
      remove.setAttribute('aria-label', 'Remove ' + item.title);
      remove.addEventListener('click', function () { window.OmbrailSelection.remove(item.reference); });
      li.append(media, body, remove);
      list.append(li);
    });
    if (!all.length) list.append(el('li', 'o-sel-drawer__empty', 'Your selection is empty. Tap Save on any piece as you browse: it appears here, and you can ask for one quote for all of them.'));
    cta.hidden = !all.length;
    if (wa) {
      wa.hidden = !all.length;
      var lines = ['Hello Ombrail, here is my selection:'];
      all.forEach(function (item, i) { lines.push((i + 1) + '. ' + item.title + (item.reference ? ' (Ref. ' + item.reference + ')' : '') + ' ' + new URL(item.url, window.location.origin).href); });
      lines.push('Could you send me a quote?');
      wa.href = 'https://wa.me/' + (window.OmbrailWhatsApp || '') + '?text=' + encodeURIComponent(lines.join('\n'));
    }
  }
  document.addEventListener('ombrail:selection-change', function () {
    if (pending !== null) {
      var ref = pending; pending = null;
      status.textContent = 'Added to your selection';
      render(ref);
      if (!drawer.open && typeof drawer.showModal === 'function') drawer.showModal();
    } else if (drawer.open) render('');
  });
  drawer.querySelectorAll('[data-o-sel-close]').forEach(function (b) { b.addEventListener('click', function () { drawer.close(); }); });
  drawer.addEventListener('click', function (e) { if (e.target === drawer) drawer.close(); });
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-o-sel-open]');
    if (!trigger) return;
    e.preventDefault(); status.textContent = items().length ? 'Saved on this device' : 'Nothing saved yet'; render(''); drawer.showModal();
  });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ombrail-selection-engine"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.OmbrailSelection) return;
  const KEY = 'ombrail.selection.v1';
  const MAX = 30;
  const copyNode = document.querySelector('[data-o-selection-copy]');
  if (!copyNode) return;
  let copy;
  try { copy = JSON.parse(copyNode.textContent); } catch { return; }
  const cleanText = (value, limit = 300) => typeof value === 'string' ? value.replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f]/g, '').trim().slice(0, limit) : '';
  const quantity = (value, minimum) => Math.max(minimum, Math.min(50, Number.isFinite(Number(value)) ? Math.floor(Number(value)) : minimum));

  function productUrl(value) {
    try {
      const url = new URL(cleanText(value, 2048), window.location.origin);
      if (url.origin !== window.location.origin || url.username || url.password) return '';
      if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/i.test(url.pathname)) return url.pathname + (/^[0-9]+$/.test(url.searchParams.get('variant') || '') ? '?variant=' + url.searchParams.get('variant') : '');
      if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/(?:projects|contact)\/?$/i.test(url.pathname) && /^[a-z0-9-]{1,180}$/.test(url.searchParams.get('piece') || '')) return url.pathname.replace(/projects\/?$/, 'contact') + '?piece=' + encodeURIComponent(url.searchParams.get('piece'));
      return '';
    } catch { return ''; }
  }

  function imageUrl(value) {
    if (!value) return '';
    try {
      const url = new URL(cleanText(value, 2048), window.location.origin);
      if (url.protocol !== 'https:' || url.username || url.password) return '';
      if (url.hostname === 'cdn.shopify.com' || (url.origin === window.location.origin && url.pathname.startsWith('/cdn/shop/'))) return url.href;
      return '';
    } catch { return ''; }
  }

  function normalize(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
    const reference = cleanText(value.reference || value.id, 80);
    const title = cleanText(value.title, 240);
    let url = productUrl(value.url);
    let variantId = /^[0-9]{1,20}$/.test(String(value.variantId || '')) ? String(value.variantId) : '';
    if (url.includes('/products/')) {
      const target = new URL(url, window.location.origin);
      if (variantId) target.searchParams.set('variant', variantId);
      else variantId = target.searchParams.get('variant') || '';
      url = productUrl(target.href);
    }
    if(url.includes('/pages/contact?piece='))url += '&reference=' + encodeURIComponent(reference) + '&title=' + encodeURIComponent(title);
    if (!/^[a-z0-9][a-z0-9._:-]{0,79}$/i.test(reference) || !title || !url) return null;
    const moq = quantity(value.moq, 1);
    const purchaseMode = ['standard', 'quote', 'hold'].includes(value.purchaseMode) ? value.purchaseMode : 'quote';
    const guidePrice = value.guideCurrency === 'SGD' && typeof value.guidePrice === 'number' && Number.isFinite(value.guidePrice) && value.guidePrice > 0 && value.guidePrice < 100000000 ? value.guidePrice : null;
    return {
      id: cleanText(String(value.id || reference), 128),
      variantId,
      reference, title, url, image: imageUrl(value.image),
      quantity: quantity(value.quantity, moq), moq,
      configuration: value.configuration === 'custom' && purchaseMode !== 'hold' ? 'custom' : 'standard',
      notes: cleanText(value.notes, 500),
      unit: value.unit === 'set' || value.unit === 'sets' ? 'set' : 'piece',
      guidePrice, guideCurrency: 'SGD', purchaseMode,
      material: cleanText(value.material, 200), dimensions: cleanText(value.dimensions, 200),
      deliveryBasis: cleanText(value.deliveryBasis, 300)
    };
  }

  function normalizeList(value) {
    if (!Array.isArray(value)) return [];
    const items = new Map();
    for (const entry of value.slice(0, MAX * 2)) {
      const item = normalize(entry);
      if (item && (items.has(item.reference) || items.size < MAX)) items.set(item.reference, item);
    }
    return [...items.values()];
  }

  function read() {
    try {
      const raw = localStorage.getItem(KEY);
      if (!raw || raw.length > 300000) return [];
      const value = JSON.parse(raw);
      return normalizeList(Array.isArray(value) ? value : value.version === 1 ? value.items : []);
    } catch { return []; }
  }

  let items = read();
  let persisted = true;
  function alert(message) {
    const node = document.querySelector('[data-o-selection-alert]');
    if (node) { node.textContent = message; node.hidden = !message; }
  }

  function notify() {
    document.querySelectorAll('[data-o-selection-count]').forEach(node => { node.textContent = String(items.length); });
    document.dispatchEvent(new CustomEvent('ombrail:selection-change', { detail: { count: items.length, persisted } }));
  }

  function save(next, rerender = true) {
    items = normalizeList(next);
    try {
      localStorage.setItem(KEY, JSON.stringify({ version: 1, items }));
      persisted = true;
      alert('');
    } catch {
      persisted = false;
      alert(copy.storageError);
    }
    notify();
    if (rerender) renderAll(); else updateSummaries();
    return persisted;
  }

  function amount(item) {
    return item.purchaseMode === 'hold' || item.configuration === 'custom' || item.guidePrice === null ? null : item.quantity * item.guidePrice;
  }

  function totals() {
    return items.reduce((sum, item) => {
      const value = amount(item);
      if (item.purchaseMode === 'hold') sum.held += 1;
      else if (value === null) sum.pending += 1;
      else { sum.known += value; sum.priced += 1; }
      if (item.purchaseMode !== 'hold') sum.quotable += 1;
      return sum;
    }, { known: 0, priced: 0, pending: 0, held: 0, quotable: 0 });
  }

  function money(value) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-SG', { style: 'currency', currency: 'SGD', maximumFractionDigits: 2 }).format(value);
  }

  function brief() {
    const lines = [copy.briefTitle, ''];
    items.forEach((item, index) => {
      lines.push(`${index + 1}. ${item.title}`, `${copy.reference}: ${item.reference}`, `${copy.quantity}: ${item.quantity} ${item.unit === 'set' ? copy.unitSet : copy.unitPiece}`, `${copy.configuration}: ${item.configuration === 'custom' ? copy.custom : copy.standard}`);
      if (item.material) lines.push(`${copy.material}: ${item.material}`);
      if (item.dimensions) lines.push(`${copy.dimensions}: ${item.dimensions}`);
      if (item.deliveryBasis) lines.push(`${copy.delivery}: ${item.deliveryBasis}`);
      if (item.notes) lines.push(`${copy.notes}: ${item.notes}`);
      lines.push(`${copy.estimate}: ${item.purchaseMode === 'hold' ? copy.held : amount(item) === null ? copy.onRequest : money(amount(item))}`, new URL(item.url, window.location.origin).href, '');
    });
    const total = totals();
    lines.push(`${copy.subtotal}: ${total.priced ? money(total.known) : copy.onRequest}`, `${copy.pending}: ${total.pending}`, `${copy.inspiration}: ${total.held}`, '', copy.disclaimer);
    return lines.join('\n');
  }

  function element(tag, text, className) {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (className) node.className = className;
    return node;
  }

  function field(labelText, input) {
    const label = element('label', undefined, 'o-selection-field');
    label.append(element('span', labelText), input);
    return label;
  }

  function patch(reference, data, rerender = true) {
    save(items.map(item => item.reference === reference ? { ...item, ...data } : item), rerender);
  }

  function line(item) {
    const article = element('article', undefined, 'o-selection-line');
    const media = element('a', undefined, 'o-selection-line__image');
    media.href = item.url;
    media.setAttribute('aria-label', item.title);
    if (item.image) {
      const image = element('img');
      image.src = item.image; image.alt = item.title; image.loading = 'lazy'; image.width = 360; image.height = 360;
      image.addEventListener('error', () => media.replaceChildren(element('span', copy.noPhoto)), { once: true });
      media.append(image);
    } else media.append(element('span', copy.noPhoto));
    const body = element('div', undefined, 'o-selection-line__body');
    body.append(element('p', item.reference, 'o-kicker'));
    const heading = element('h2');
    const link = element('a', item.title); link.href = item.url; heading.append(link); body.append(heading);
    if (item.material || item.dimensions) body.append(element('p', [item.material, item.dimensions].filter(Boolean).join(' · '), 'o-selection-line__spec'));
    if (item.purchaseMode === 'hold') body.append(element('p', copy.held, 'o-selection-line__hold'));
    const controls = element('div', undefined, 'o-selection-line__controls');
    const quantityInput = element('input');
    quantityInput.type = 'number'; quantityInput.inputMode = 'numeric'; quantityInput.min = String(item.moq); quantityInput.max = '50'; quantityInput.step = '1'; quantityInput.value = String(item.quantity);
    quantityInput.addEventListener('change', () => patch(item.reference, { quantity: quantityInput.value }));
    const quantityField = field(`${copy.quantity} (${item.unit === 'set' ? copy.unitSet : copy.unitPiece})`, quantityInput);
    quantityField.append(element('small', `${copy.minimum}: ${item.moq}`)); controls.append(quantityField);
    if (item.purchaseMode !== 'hold') {
      const configuration = element('select');
      [['standard', copy.standard], ['custom', copy.custom]].forEach(([value, label]) => { const option = element('option', label); option.value = value; configuration.append(option); });
      configuration.value = item.configuration;
      configuration.addEventListener('change', () => patch(item.reference, { configuration: configuration.value }));
      controls.append(field(copy.configuration, configuration));
    }
    body.append(controls);
    const notes = element('textarea'); notes.rows = 2; notes.maxLength = 500; notes.value = item.notes;
    notes.addEventListener('input', () => patch(item.reference, { notes: notes.value }, false));
    body.append(field(copy.notes, notes));
    const foot = element('div', undefined, 'o-selection-line__foot');
    foot.append(element('p', item.purchaseMode === 'hold' ? copy.inspiration : `${copy.estimate}: ${amount(item) === null ? copy.onRequest : money(amount(item))}`));
    const remove = element('button', copy.remove, 'o-link'); remove.type = 'button'; remove.setAttribute('aria-label', `${copy.remove}: ${item.title}`);
    remove.addEventListener('click', () => save(items.filter(entry => entry.reference !== item.reference))); foot.append(remove); body.append(foot);
    article.append(media, body);
    return article;
  }

  function updateSummaries() {
    const total = totals();
    document.querySelectorAll('[data-o-selection]').forEach(root => {
      root.querySelectorAll('[data-o-selection-subtotal]').forEach(node => { node.textContent = total.priced ? money(total.known) : copy.onRequest; });
      root.querySelectorAll('[data-o-selection-pending]').forEach(node => { node.textContent = String(total.pending); });
      root.querySelectorAll('[data-o-selection-held]').forEach(node => { node.textContent = String(total.held); });
      root.querySelectorAll('[data-o-selection-send]').forEach(node => { node.disabled = total.quotable === 0; });
      root.querySelectorAll('[data-o-selection-download]').forEach(node => { node.disabled = !items.length; });
      root.querySelectorAll('[data-o-selection-body]').forEach(node => { node.value = brief(); });
      root.querySelectorAll('[data-o-selection-empty]').forEach(node => { node.hidden = items.length > 0; });
      root.querySelectorAll('[data-o-selection-filled]').forEach(node => { node.hidden = items.length === 0; });
      root.querySelectorAll('[data-o-selection-hold-only]').forEach(node => { node.hidden = !items.length || total.quotable > 0; });
      root.querySelectorAll('[data-o-selection-storage]').forEach(node => { node.hidden = !persisted; });
    });
  }

  function renderAll() {
    document.querySelectorAll('[data-o-selection-lines]').forEach(node => { node.replaceChildren(...items.map(line)); });
    updateSummaries();
  }

  function connect() {
    document.querySelectorAll('[data-o-selection]').forEach(root => {
      if (root.dataset.oSelectionConnected) return;
      root.dataset.oSelectionConnected = 'true';
      const form = root.querySelector('form[data-o-selection-form]');
      if (form) form.addEventListener('submit', event => {
        if (!totals().quotable) { event.preventDefault(); alert(copy.emptyError); return; }
        if (!form.reportValidity()) { event.preventDefault(); return; }
        const body = form.querySelector('[data-o-selection-body]');
        if (body) body.value = brief();
      });
      root.querySelectorAll('[data-o-selection-download]').forEach(button => button.addEventListener('click', () => {
        if (!items.length) return;
        try {
          const blob = new Blob([brief()], { type: 'text/plain;charset=utf-8' });
          const url = URL.createObjectURL(blob);
          const link = element('a'); link.href = url; link.download = 'Ombrail-selection.txt'; document.body.append(link); link.click(); link.remove();
          setTimeout(() => URL.revokeObjectURL(url), 1000);
        } catch { alert(copy.downloadError); }
      }));
    });
    renderAll(); notify();
  }

  document.addEventListener('ombrail:add-selection', event => {
    const item = normalize(event.detail);
    if (!item) { alert(copy.invalidError); return; }
    const exists = items.some(entry => entry.reference === item.reference);
    if (!exists && items.length >= MAX) { alert(copy.limitError); return; }
    const next = exists ? items.map(entry => entry.reference === item.reference ? item : entry) : [...items, item];
    if (save(next) && event.detail.stay !== true) window.location.assign(copy.selectionUrl);
  });
  window.addEventListener('storage', event => {
    if (event.key !== KEY && event.key !== null) return;
    items = read(); persisted = true; renderAll(); notify();
  });
  document.addEventListener('shopify:section:load', connect);
  window.OmbrailSelection = Object.freeze({ getItems: () => items.map(item => ({ ...item })), getTotals: totals, isPersisted: () => persisted, remove: reference => save(items.filter(item => item.reference !== reference)) });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, { once: true }); else connect();
})();
  } catch(e) { console.error(e); }
})();

})();
